module.exports = __webpack_public_path__ + "media/media/product-card/item-1-9fea0d07d7b0434f673865adbfe14685.png";